// api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://card.flap.com.np/api',   // your backend port
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 100000,   // 100 seconds - good balance (don't make it millions)
});

api.interceptors.request.use(
  (config) => {
    console.log('API Request →', config.method.toUpperCase(), config.url);
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.message,
      responseData: error.response?.data,
    });
    return Promise.reject(error);
  }
);

export default api;